'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var Image2 = function Image2(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 15 14' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M4 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm10 6.123l-3.645-4.546a.495.495 0 0 0-.362-.186.473.473 0 0 0-.381.144L5.349 8.777 3.633 7.605a.501.501 0 0 0-.597.025L1 9.282V1.5a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v7.623zm0 3.377a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-1.93l2.376-1.928 1.75 1.195a.499.499 0 0 0 .635-.059l4.162-4.141L14 10.722V12.5zM13.5 0h-12C.673 0 0 .673 0 1.5v11c0 .827.673 1.5 1.5 1.5h12c.827 0 1.5-.673 1.5-1.5v-11c0-.827-.673-1.5-1.5-1.5z',
        fillRule: 'evenodd' })
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = Image2;